import React from "react";
import IconsRow from "../components/IconsRow/IconsRow";
import ProductCardsRow from "../components/ProductCardsRow/ProductCardsRow";
import LegalTable from "../components/Tables/LegalTable/LegalTable";
import CompareTable from "../components/Tables/CompareTable/CompareTable";
import CompareWith from "../components/CompareWith/CompareWith";
import ImageBanner from "../components/Banners/ImageBanner";
import CardsContainer from "../components/Featured_Cards/FeaturedCards";
import Feature_Content from "../components/Feature_Content/Feature_Content";
import Header from "../components/Headers/Header";
import WhatsIncluded from "../components/Whats_Included/WhatsIncluded";
import FeaturedArticles from "../components/Articles/FeaturedArticles";
import Navigation_Header from "../components/Headers/Navigation_Header";
import PinkBanner from "../components/Banners/PinkBanner";
import PolicyCards from "../components/PolicyCards/PolicyCards";
import Faq from "../components/FAQ/Faq";
import Accordion from "../components/Accordion/Accordion";
import SecondaryHeader from "../components/Headers/SecondaryHeader";
import Text from "../components/Basic/Text";
import Html from "../components/Basic/Html";
import Title from "../components/Basic/Title";
import TitleText from "../components/Basic/TitleText";
import Image from "../components/Basic/Image";
import ButtonBasic from "../components/Basic/Button";
import TertiaryHeader from "../components/Headers/TertiaryHeader";
import HeaderCalculator from "../components/Headers/HeaderCalculator";
import CalculatorModule from "../components/CalculatorModule/CalculatorModule";
import SnackbarComponent from "../components/Snackbar/Snackbar";
import EmbeddedCalculator from "../components/EmbeddedCalculator/EmbeddedCalculator";
import ContentTable from "../components/ContentTable/ContentTable";
import Buttons from "../components/Buttons/Buttons";
import HeroCalculatorImage from "../components/HeroCalculatorImage/HeroCalculatorImage";
import HeroCalculatorContent from "../components/HeroCalculatorContent/HeroCalculatorContent";
import HeroIndependentCalculator from "../components/HeroIndependentCalculator/HeroIndependentCalculator";
import HeroPrimary from "../components/HeroPrimary/HeroPrimary";
import HeroMinimalist from "../components/HeroMinimalist/HeroMinimalist";
import BannerMinimalist from "../components/BannerMinimalist/BannerMinimalist";
import BannerRich from "../components/BannerRich/BannerRich";
import IconCards from "../components/IconCards/IconCards";
import BannerTitleImage from "../components/BannerTitleImage/BannerTitleImage";
import BannerImage from "../components/BannerImage/BannerImage";
import Iframe from "../components/Iframe/Iframe";
import AnchorLink from "../components/AnchorLink/AnchorLink";

// These were React.lazy + <Suspense fallback={<div min-h-[200px]/>}> (heavy
// deps: swiper, react-spring). Two documented failure modes forced sync imports
// (same rationale as the 2026-04 Accordion fix):
//   1. renderToString + React.lazy is non-deterministic: pages built before the
//      chunk resolves ship the 200px fallback shell in their static HTML (block
//      content + JSON-LD missing, grows into place client-side = CLS + SEO loss).
//   2. On hydration-mismatch recovery (#418) React discards the SSR DOM; every
//      unresolved lazy block collapses to its 200px fallback until its chunk
//      arrives, then re-expands (~2000px of movement measured on life5.it home
//      = field CLS fail on desktop, 2026-08-08).
// Bundle cost is absorbed by the per-template chunk preloads from the INP fix A.
// ProtectionCalculator keeps its INTERNAL lazy funnels (user-triggered, not SSR'd).
import ProductCarousel from "../components/Carousel/ProductCarousel";
import TrustPilot from "../components/TrustPilot/TrustPilot";
import AnimatedImageText from "../components/AnimatedImageText/AnimatedImageText";
import PromoBanner from "../components/Banners/PromoBanner";
import USPIconRow from "../components/USPIconRow/USPIconRow";
import ComparisonCards from "../components/ComparisonCards/ComparisonCards";
import ReviewCards from "../components/ReviewCards/ReviewCards";
import Reviews from "../components/Reviews/Reviews";
import ImageCards from "../components/ImageCards/ImageCards";
import PriceCards from "../components/PriceCards/PriceCards";
import ComparativeTable from "../components/ComparativeTable/ComparativeTable";
import FormWealthReader from "../components/FormWealthReader/FormWealthReader";
import ProtectionCalculator from "../components/ProtectionCalculator/ProtectionCalculator";

// life5.fr shows no customer reviews or ratings (Carlos, 2026-10-27): France
// no longer onboards customers and the only reviews available were Spain's.
// The blocks stay in the FR Strapi; they just never render on the FR market.
const HIDE_REVIEWS = process.env.GATSBY_APP_LOCALE === "fr";

const ComponentMap: any = {
  Strapi_ComponentComponentPromoBanner: (v: any) => (
    <PromoBanner data={v} key={v.id} />
  ),
  Strapi_ComponentComponentLegalTable: (v: any) => (
    <LegalTable data={v} key={v.id} />
  ),
  Strapi_ComponentComponentCompareTable: (v: any) => (
    <CompareTable data={v} key={v.id} />
  ),
  Strapi_ComponentComponentAccordion: (v: any) => (
    <Accordion data={v} key={v.id} />
  ),
  Strapi_ComponentComponentTrustPilotCarousel: (v: any) =>
    HIDE_REVIEWS ? null : <TrustPilot data={v} key={v.id} />,
  // Legacy schema (component.trust-pilot — Title + Button only). No frontend
  // equivalent exists; render nothing but register the handler to silence the
  // "no handler for __typename" warning.
  Strapi_ComponentComponentTrustPilot: () => <></>,
  Strapi_ComponentComponentCompareWith: (v: any) => (
    <CompareWith data={v} key={v.id} />
  ),
  Strapi_ComponentComponentUspIcons: (v: any) => (
    <USPIconRow data={v} key={v.id} />
  ),
  Strapi_ComponentComponentIconsRow: (v: any) => (
    <IconsRow data={v} key={v.id} />
  ),
  Strapi_ComponentComponentProductCardsRow: (v: any) => (
    <ProductCardsRow data={v} key={v.id} />
  ),
  Strapi_ComponentComponentImageBanner: (v: any) => (
    <ImageBanner data={v} key={v.id} />
  ),
  Strapi_ComponentComponentFeaturedCards: (v: any) => (
    <CardsContainer data={v} key={v.id} />
  ),
  Strapi_ComponentComponentFeatureContent: (v: any) => (
    <Feature_Content data={v} key={v.id} />
  ),
  Strapi_ComponentComponentWhatsIncluded: (v: any) => (
    <WhatsIncluded data={v} key={v.id} />
  ),
  Strapi_ComponentComponentHeader: (v: any) => <Header data={v} key={v.id} />,
  Strapi_ComponentComponentSecondaryHeader: (v: any) => (
    <SecondaryHeader data={v} key={v.id} />
  ),
  Strapi_ComponentComponentTertiaryHeader: (v: any) => (
    <TertiaryHeader data={v} key={v.id} />
  ),
  Strapi_ComponentComponentAnimatedLines: (v: any) => (
    <AnimatedImageText data={v} key={v.id} />
  ),

  Strapi_ComponentComponentProductCarousel: (v: any) => (
    <ProductCarousel data={v} key={v.id} />
  ),
  Strapi_ComponentComponentNavigationHeader: (v: any) => (
    <Navigation_Header data={v} key={v.id} />
  ),
  Strapi_ComponentComponentFeaturedArticles: (v: any) => (
    <FeaturedArticles data={v} key={v.id} />
  ),
  Strapi_ComponentComponentPinkBanner: (v: any) => (
    <PinkBanner data={v} key={v.id} />
  ),
  Strapi_ComponentComponentPolicyCards: (v: any) => (
    <PolicyCards data={v} key={v.id} />
  ),
  Strapi_ComponentComponentFaqListings: (v: any) => <Faq data={v} key={v.id} />,
  Strapi_ComponentBasicTitle: (v: any) => <Title data={v} key={v.id} />,
  Strapi_ComponentBasicText: (v: any) => <Text data={v} key={v.id} />,
  Strapi_ComponentBasicHtml: (v: any) => <Html data={v} key={v.id} />,
  Strapi_ComponentBasicImage: (v: any) => <Image data={v} key={v.id} />,
  Strapi_ComponentBasicTitleText: (v: any) => <TitleText data={v} key={v.id} />,
  Strapi_ComponentBasicButton: (v: any) => <ButtonBasic data={v} key={v.id} />,
  // HubSpot decommissioned 2026-09: the legacy component.hubspot-form block
  // (only left in 2 unpublished drafts) renders nothing.
  Strapi_ComponentComponentHubspotForm: () => <></>,
  Strapi_ComponentComponentHeaderCalculator: (v: any) => <HeaderCalculator data={v} key={v.id} />,
  Strapi_ComponentComponentCalculatorModule: (v: any) => <CalculatorModule data={v} key={v.id} />,
  Strapi_ComponentComponentSnackbar: (v: any) => <SnackbarComponent data={v} key={v.id} />,
  Strapi_ComponentComponentEmbeddedCalculator: (v: any) => <EmbeddedCalculator data={v} key={v.id} />,
  Strapi_ComponentComponentContentTable: (v: any) => <ContentTable data={v} key={v.id} />,
  Strapi_ComponentComponentButtons: (v: any) => <Buttons data={v} key={v.id} />,
  Strapi_ComponentComponentHeroCalculatorImage: (v: any) => <HeroCalculatorImage data={v} key={v.id} />,
  Strapi_ComponentComponentHeroCalculatorContent: (v: any) => <HeroCalculatorContent data={v} key={v.id} />,
  Strapi_ComponentComponentHeroIndependentCalculator: (v: any) => <HeroIndependentCalculator data={v} key={v.id} />,
  Strapi_ComponentComponentHeroPrimary: (v: any) => <HeroPrimary data={v} key={v.id} />,
  Strapi_ComponentComponentHeroMinimalist: (v: any) => <HeroMinimalist data={v} key={v.id} />,
  Strapi_ComponentComponentBannerMinimalist: (v: any) => <BannerMinimalist data={v} key={v.id} />,
  Strapi_ComponentComponentBannerRich: (v: any) => <BannerRich data={v} key={v.id} />,
  Strapi_ComponentComponentIconCards: (v: any) => <IconCards data={v} key={v.id} />,
  Strapi_ComponentComponentComparisonCards: (v: any) => (
    <ComparisonCards data={v} key={v.id} />
  ),
  Strapi_ComponentComponentBannerTitleImage: (v: any) => <BannerTitleImage data={v} key={v.id} />,
  Strapi_ComponentComponentBannerImage: (v: any) => <BannerImage data={v} key={v.id} />,
  Strapi_ComponentComponentReviewCards: (v: any) =>
    HIDE_REVIEWS ? null : <ReviewCards data={v} key={v.id} />,
  Strapi_ComponentComponentReviews: (v: any, locale?: string) =>
    HIDE_REVIEWS ? null : <Reviews data={v} locale={locale} key={v.id} />,
  Strapi_ComponentComponentImageCards: (v: any) => (
    <ImageCards data={v} key={v.id} />
  ),
  Strapi_ComponentComponentIframe: (v: any) => <Iframe data={v} key={v.id} />,
  Strapi_ComponentComponentAnchorLink: (v: any) => <AnchorLink data={v} key={v.id} />,
  Strapi_ComponentComponentPriceCards: (v: any) => (
    <PriceCards data={v} key={v.id} />
  ),
  Strapi_ComponentComponentComparativeTable: (v: any) => (
    <ComparativeTable data={v} key={v.id} />
  ),
  Strapi_ComponentComponentFormWealthReader: (v: any) => (
    <FormWealthReader data={v} key={v.id} />
  ),
  Strapi_ComponentComponentProtectionCalculator: (v: any) => (
    <ProtectionCalculator data={v} key={v.id} />
  ),
};

export const componentBuilder = (strapiComponents: any[] | null | undefined, locale?: string) => {
  if (!Array.isArray(strapiComponents)) return [];
  const components = strapiComponents.map((component) => {
    let itemsResult = undefined;

    try {
      // find matching component type (try with and without Strapi_ prefix)
      let builderFn = ComponentMap[component.__typename]
        || ComponentMap[`Strapi_${component.__typename}`];
      if (!builderFn) {
        console.warn(`componentBuilder: no handler for __typename "${component.__typename}"`);
        return <></>;
      }
      // call build function to a JSX component. `locale` (page locale, e.g.
      // "es-ES" / "en") is forwarded so locale-aware blocks (Reviews CTAs) can
      // render the right language; handlers that don't need it ignore it.
      itemsResult = builderFn(component, locale);
    } catch (e: any) {
      console.error(`componentBuilder: error rendering "${component.__typename}":`, e?.message || e);
    }

    if (itemsResult === undefined) {
      return <></>;
    }
    return itemsResult;
  });
  return components;
};
